/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */


import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import * as models from '../model/models';
import { Requester } from '../requester';
import { PagedArray } from '../paged-array';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class TermsApi {
    constructor(
        protected requester: Requester
    ) {
    }

    /**
     * Get a terms documents&#39;s content
     * @param kind 
     */
    public get(kind?: string, __unused?: any): Observable<models.ApiTermsDocument> {
        const path = '/terms/{kind}'
                    .replace('{' + 'kind' + '}', String(kind));

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<models.ApiTermsDocument>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

}
